export var ReactRouterVersion;
(function (ReactRouterVersion) {
  ReactRouterVersion["V4"] = "v4";
  ReactRouterVersion["V5"] = "v5";
  ReactRouterVersion["V6"] = "v6";
  ReactRouterVersion["V6_data_router"] = "v6_data_router";
})(ReactRouterVersion || (ReactRouterVersion = {}));
export var NavigationType;
(function (NavigationType) {
  NavigationType["Pop"] = "POP";
  NavigationType["Push"] = "PUSH";
  NavigationType["Replace"] = "REPLACE";
})(NavigationType || (NavigationType = {}));